import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import queryString from "query-string"
import { spouseApplicationSteps } from "../../Redux/Reducers/SpouseApplication/spouseApplicationMetadata"
import UserFieldEditorHeader from "../UserFieldEditorHeader/UserFieldEditorHeader"

const SpouseApplicationHeader = (props) => {
  return (
    <UserFieldEditorHeader
      sectionTitle={props.sectionTitle}
      title={props.title}
      currentStepIndex={props.currentStepIndex}
      stepsLength={props.stepsLength}
      description={props.description}
    />
  )
}

const mapStateToProps = (state, props) => {
  const willLocate = state.spouseApplication.userWillReLocate
  const pageTitle = queryString.parse(props.history.location.search).title
  const { stepId } = spouseApplicationSteps.find((elem) => elem.stepId === pageTitle)
  const item = state.spouseApplication.spouseApplicationMetadata.find((spouseApplication) =>
    spouseApplication.steps.some((step) => step.stepId === stepId)
  )
  const step = item.steps.find((step) => step.stepId === stepId)
  
  // Filter steps based on willLocate condition
  const filteredSteps = item.steps.filter((step) =>
    step.stepId === "relocation" ? Boolean(willLocate) : true
  )
  
  return {
    title: step.title,
    sectionTitle: item.title,
    stepsLength: filteredSteps.length,
    currentStepIndex: filteredSteps.findIndex((step) => step.stepId === stepId),
    description: step.body
  }
}

export default withRouter(connect(mapStateToProps)(SpouseApplicationHeader))
